import { render } from "./mail-index.vue?vue&type=template&id=b945600a&scoped=true"
import script from "./mail-index.vue?vue&type=script&lang=js"
export * from "./mail-index.vue?vue&type=script&lang=js"

import "./mail-index.vue?vue&type=style&index=0&id=b945600a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b945600a"]])

export default __exports__